<template>
    <div class="collage-carousel">
      <div class="collage-grid">
        <div
          v-for="(image, index) in images"
          :key="index"
          ref="collageItems"
          class="collage-item"
          :class="{ visible: imageVisible[index] }"
          @click="enlargeImage(index)"
        >
          <img
            :src="image"
            class="collage-image"
            :alt="'Imagen ' + index"
          >
        </div>
      </div>
  
      <!-- Modal -->
      <div
        v-if="isImageEnlarged"
        class="image-modal"
        @click="closeModal"
      >
        <img
          :src="images[currentIndex]"
          class="enlarged-image"
        >
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted, nextTick } from 'vue'
  import gsap from 'gsap'
  
  export default {
    name: 'CollageAnimado',
    setup() {
      const images = [
      require('@/assets/foto 11.jpg'),
         




      ]
  
      const currentIndex = ref(0)
      const isImageEnlarged = ref(false)
      const collageItems = ref([])
      const imageVisible = ref(new Array(images.length).fill(false))
  
      const enlargeImage = (index) => {
        currentIndex.value = index
        isImageEnlarged.value = true
      }
  
      const closeModal = () => {
        isImageEnlarged.value = false
      }
  
      const observeImages = () => {
        const options = { threshold: 0.2 }
  
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const index = collageItems.value.indexOf(entry.target)
            if (entry.isIntersecting) {
              imageVisible.value[index] = true
              animateIn(entry.target, index)
            }
          })
        }, options)
  
        collageItems.value.forEach((el) => observer.observe(el))
      }
  
      const animateIn = (el, index) => {
        const animations = [
          { from: { opacity: 0, y: 80 }, to: { opacity: 1, y: 0 } },
          { from: { opacity: 0, x: -80 }, to: { opacity: 1, x: 0 } },
          { from: { scale: 0.8, opacity: 0 }, to: { scale: 1, opacity: 1 } },
          { from: { rotate: 15, opacity: 0 }, to: { rotate: 0, opacity: 1 } },
          { from: { x: 60, scale: 0.9, opacity: 0 }, to: { x: 0, scale: 1, opacity: 1 } },
        ]
        const type = animations[index % animations.length]
  
        gsap.fromTo(el, type.from, {
          ...type.to,
          duration: 1.2,
          ease: 'power3.out'
        })
      }
  
      onMounted(async () => {
        await nextTick()
        collageItems.value = collageItems.value.slice(0, images.length)
        observeImages()
      })
  
      return {
        images,
        currentIndex,
        isImageEnlarged,
        enlargeImage,
        closeModal,
        collageItems,
        imageVisible,
      }
    }
  }
  </script>
  
  <style scoped>
  .collage-carousel {
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
  }
  
  .collage-grid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 0;
  }
  
  .collage-item {
    grid-column: span 12;
    opacity: 0;
    cursor: pointer;
    transition: transform 0.3s ease;
  }
  
  .collage-item.visible {
    opacity: 1;
  }
  
  .collage-image {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 0;
    display: block;
    box-shadow: none;
    transition: transform 0.3s ease;
  }
  
  .collage-image:hover {
    transform: scale(1.03);
  }
  
  /* Modal */
  .image-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(10, 10, 10, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }
  
  .enlarged-image {
    max-width: 90%;
    max-height: 90%;
    border-radius: 12px;
    object-fit: contain;
  }
  </style>
  